import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MirActionPanelComponent } from './action-panel.component';
import { ActionGroupDirective } from './directives';

const PUBLIC = [
  MirActionPanelComponent,
  ActionGroupDirective
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: PUBLIC,
  exports: PUBLIC,
})
export class ActionPanelModule { }


